export default __webpack_public_path__ + "images/maintenance-c5fb8e.svg";